import Vue from 'vue'
import Router from 'vue-router'
import _ from 'lodash'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        {
          path: '/',
          redirect: '/login'
        },
        {
          path: '/dashboard/analytics',
          name: 'dashboard-analytics',
          component: () => import('./views/DashboardAnalytics.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/task/list',
          name: 'tasks-list',
          component: () => import('./views/tasks/TaskList.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/task/list/search/:query',
          name: 'tasks-list-search',
          component: () => import('./views/tasks/TaskList.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/task',
          name: 'task',
          component: () => import('./views/tasks/task.vue'),
          meta: {
            rule: 'editor',
          }
        },
        {
          path: '/task/add',
          name: 'tasks-add',
          component: () => import('./views/tasks/AddTask.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/task/type',
          name: 'tasks-type',
          component: () => import('./views/tasks/TaskType.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Task Type'
          }
        },
        {
          path: '/task/lists',
          name: 'tasks-lists',
          component: () => import('./views/tasks/TaskLists.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Task lists'
          }
        },
        {
          path: '/task/report',
          name: 'tasks-report',
          component: () => import('./views/tasks/reports/TaskReport.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Task Report'
          }
        },
        {
          path: '/task/lists/template/:id',
          name: 'tasks-template',
          component: () => import('./views/tasks/TaskTemplate.vue'),
          meta: {
            rule: 'editor',
            pageTitle: 'Task template'
          }
        },
        {
          path: '/matters',
          name: 'matters',
          component: () => import('./views/matters/Matters.vue'),
          meta : {
            rule: 'editor'
          }
        },
        {
          path: '/matters/search/:query',
          name: 'matters-search',
          component: () => import('./views/matters/Matters.vue'),
          meta : {
            rule: 'editor'
          }
        },
        {
          path: '/matters/dashboard/:id',
          component: () => import('./views/matters/DashboardMatters.vue'),
          meta : {
            rule: 'editor'
          }
        },
        {
          path: '/matters/add',
          name: 'matters-add',
          component: () => import('./views/matters/addMatter.vue'),
          meta : {
            rule: 'editor'
          }
        },
        {
          path: '/matters/edit/:id',
          name: 'matters-edit',
          component: () => import('./views/matters/editMatter.vue'),
          meta : {
            rule: 'editor'
          }
        },
        {
          path: '/contacts',
          name: 'contacts',
          component: () => import('./views/contacts/Contact.vue'),
          meta : {
            rule: 'editor',
          }
        },
        {
          path: '/contacts/search/:query',
          name: 'contacts-search',
          component: () => import('./views/contacts/Contact.vue'),
          meta : {
            rule: 'editor',
          }
        },
        {
          path: '/contacts/add',
          name: 'contacts-add',
          component: () => import('./views/contacts/ContactAdd.vue'),
          meta : {
            rule: 'editor'
          }
        },
        {
          path: '/contacts/edit/:id/',
          name: 'contacts-edit',
          component: () => import('./views/contacts/ContactEdit.vue'),
          meta : {
            rule: 'editor'
          }
        },
        {
          path: '/contacts/dashboard/:id',
          name:'dashboard-contact',
          component: () => import('./views/contacts/DashboardContact'),
          props: (route) => ({
            id: route.params.id,
          }),
          meta : {
            rule: 'editor'
          }
        },
        {
          path: '/notes',
          name: 'notes',
          component: () => import('./views/note/Listnote.vue'),
          meta : {
            rule: 'editor'
          }
        },
        {
          path: '/notes/add',
          name: 'note-add',
          component: () => import('./views/note/AddNote.vue'),
          meta : {
            rule: 'editor',
          }
        },
        {
          path: '/notes/edit/:id',
          name: 'note-edit',
          component: () => import('./views/note/EditNote.vue'),
          meta : {
            rule: 'editor'
          }
        },
        {
          path: '/activities',
          name: 'Activities',
          component: () => import('./views/activites/ActivitesList.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/documents',
          name: 'documents',
          component: () => import('./views/documents/Documents.vue'),
          meta: {
            // breadcrumb: [
            //   { title: 'All', url: '/documents' },
            //   { title: 'eCommerce'},
            //   { title: 'Shop', active: true }
            // ],
            rule: 'admin'
          }
        },
        {
          path: '/documents/search/:query',
          name: 'documents-search',
          component: () => import('./views/documents/Documents.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/communications',
          name: 'communications',
          component: () => import('./views/communications/Communications.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/reports',
          name: 'reports',
          component: () => import('./views/reports/Reports.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/billing',
          name: 'billing',
          component: () => import('./views/billing/BillingList.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/billing/search/:query',
          name: 'billing-search',
          component: () => import('./views/billing/BillingList.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/billing/add',
          name: 'billing-add',
          component: () => import('./views/billing/BillingAdd.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/billing/edit/:id',
          name: 'billing-edit',
          component: () => import('./views/billing/BillingEdit.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/billing/record-payment',
          name: 'billing-payment',
          component: () => import('./views/billing/BillingPayment.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/billing/request-fund',
          name: 'billing-request-fund',
          component: () => import('./views/billing/BillingRequestFund.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/billing/dashboard/:id',
          name: 'billing-dashboard',
          component: () => import('./views/billing/BillingDashboard.vue'),
          meta: {
            rule: 'admin'
          }
        },
        {
          path: '/account',
          name: 'account',
          component: () => import('./views/account/AccountList.vue'),
          meta: {
            rule: 'admin',
            // pageTitle:'Bank account'
          }
        },
        {
          path: '/account/:id',
          name: 'account transaction',
          component: () => import('./views/account/AccountTransaction.vue'),
          meta: {
            rule: 'admin',
            pageTitle:'Transaction'
          }
        },
        {
          path: '/settings/:code?',
          name: 'settings',
          component: () => import('@/views/pages/user-settings/UserSettings.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pages' },
              { title: 'Settings', active: true }
            ],
            pageTitle: 'Settings',
            rule: 'editor'
          }
        },
        {
          path: '/calendar',
          name: 'calendar-simple-calendar',
          component: () => import('./views/calender/Calender.vue'),
          meta: {
            rule: 'editor',
            no_scroll: false,
          }
        },
        {
          path: '/calendar/events',
          name: 'calendar-events',
          component: () => import('./views/calender/Events.vue'),
          meta: {
            rule: 'editor',
          }
        },
        {
          path: '/permissions/role/:id',
          name: 'permissions-role',
          props: true,
          component: () => import('./views/permission/RolePermissions.vue'),
          meta: {
            rule: 'editor',
            no_scroll: true
          }
        },
        {
          path: '/permissions/:id',
          name: 'permissions',
          props: true,
          component: () => import('./views/permission/Permissions.vue'),
          meta: {
            rule: 'editor',
            no_scroll: true
          }
        },
        {
          path: '/detail-payment',
          name: 'detail-payment',
          component: () => import('./views/payment/Payment.vue'),
          meta: {
            rule: 'editor',
            no_scroll: true
          }
        },
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/permission-denied',
          name: 'permission-denied',
          component: () => import('@/views/pages/PermissionDenied.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/buy-plan',
          name: 'buy-plan',
          component: () => import('@/views/pages/user-settings/system/Plans.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/callback',
          name: 'auth-callback',
          component: () => import('@/views/Callback.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/login/:code?',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/register',
          name: 'page-register',
          component: () => import('@/views/pages/register/Register.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/verify',
          name: 'verify',
          component: () => import('./views/pages/verify/ConfirmVerify.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/forgot-password',
          name: 'forgot-password',
          component: () => import('@/views/pages/verify/ForgotPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/reset-password',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/lock-screen',
          name: 'page-lock-screen',
          component: () => import('@/views/pages/LockScreen.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/comingsoon',
          name: 'page-coming-soon',
          component: () => import('@/views/pages/ComingSoon.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/maintenance',
          name: 'page-maintenance',
          component: () => import('@/views/pages/Maintenance.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/template',
          name: 'Template',
          component: () => import('@/views/template/Template.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

const noneAuthUrl = [
  '/login',
  '/register',
  '/verify',
  '/forgot-password',
  '/reset-password'
]

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('accessToken');
  if (_.indexOf(noneAuthUrl, to.path) > -1) {
    return next();
  }
  if(token){
    return next()
  }else{
    return router.push({ path: '/login' })
  }
  if(to.path === '/'){
    return router.push({ path: '/login' })
  }
})

export default router
